// extracted by mini-css-extract-plugin
export default {"imageWrapper":"hK-z","twoColumnImage":"iK-z"};